import React, { Suspense, lazy, useEffect } from 'react'
import { Landing } from './pages/Landing'
import { Route, Routes } from 'react-router-dom';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Players from './pages/players/Players';
import ConnectErrorBoundary from './pages/connect/ConnectErrorBoundary';

// StatsConnect pages load on demand so the rest of the site doesn't carry
// their code (react-markdown etc.) in the main bundle.
const ConnectMain = lazy(() => import('./pages/connect/ConnectMain'));
const ConnectSegment = lazy(() => import('./pages/connect/ConnectSegment'));
// A lazy page whose code can be loaded before the first render. Used for the prerendered pages
// (scripts/prerender.js): index.js loads the page's chunk first, so the app replaces the saved markup with
// the same page in one step instead of passing through the Suspense fallback.
const preloadable = (load) => {
    let Loaded = null;
    const Lazy = lazy(() => load().then((component) => ({ default: component })));
    const Page = (props) => (Loaded ? <Loaded {...props} /> : <Lazy {...props} />);
    Page.preload = () =>
        load().then((component) => {
            Loaded = component;
        });
    return Page;
};

const ConnectHelp = preloadable(() => import('./pages/connect/ConnectHelp').then((m) => m.default));
const ConnectDemo = lazy(() => import('./pages/connect/ConnectDemo'));
const ConnectPlans = lazy(() => import('./pages/connect/ConnectPlans'));
// Hidden sales page (opened only through a sales link; noindex, not prerendered).
const ConnectAsk = lazy(() => import('./pages/connect/ConnectAsk'));
const ConnectPrivacy = preloadable(() => import('./pages/connect/ConnectLegal').then((m) => m.ConnectPrivacy));
const ConnectTerms = preloadable(() => import('./pages/connect/ConnectLegal').then((m) => m.ConnectTerms));

const PRERENDERED = {
    '/connect/help': ConnectHelp,
    '/connect/privacy': ConnectPrivacy,
    '/connect/terms': ConnectTerms,
};

/** Loads the code of a prerendered page before the first render; resolves at once for any other path. */
export const preloadPrerendered = (pathname) => {
    const page = PRERENDERED[pathname.replace(/\/+$/, '')];
    return page ? page.preload() : Promise.resolve();
};

const connectPage = (element) => (
    <ConnectErrorBoundary>
        <Suspense fallback={<div style={{ minHeight: '100vh', background: '#070707' }} aria-busy="true" />}>{element}</Suspense>
    </ConnectErrorBoundary>
);

const App = () => {
    // Pages prerendered at build time (scripts/prerender.js) carry a copy of their styles for clients
    // without JavaScript; once the app has rendered, its own styles are in place and the copy goes.
    useEffect(() => {
        document.querySelectorAll('style[data-prerender]').forEach((el) => el.remove());
    }, []);

    return (
        <Routes>
            <Route path="/" element={<Landing />}></Route>
            {/* Player PWA landing */}
            <Route path="/players" element={<Players />}></Route>
            {/* StatsConnect (MCP connector) landing */}
            <Route path="/connect" element={connectPage(<ConnectMain />)}></Route>
            <Route path="/connect/agents" element={connectPage(<ConnectSegment key="agent" segment="agent" />)}></Route>
            <Route path="/connect/clubs" element={connectPage(<ConnectSegment key="club" segment="club" />)}></Route>
            <Route path="/connect/help" element={connectPage(<ConnectHelp />)}></Route>
            <Route path="/connect/demo" element={connectPage(<ConnectDemo />)}></Route>
            <Route path="/connect/plans" element={connectPage(<ConnectPlans />)}></Route>
            <Route path="/connect/ask" element={connectPage(<ConnectAsk />)}></Route>
            <Route path="/connect/privacy" element={connectPage(<ConnectPrivacy />)}></Route>
            <Route path="/connect/terms" element={connectPage(<ConnectTerms />)}></Route>
            {/* Privacy pages */}
            <Route path="/terms" element={<Terms />}></Route>
            <Route path="/privacy" element={<Privacy />}></Route>
        </Routes>
    )
}
export default App;
